import React from 'react';

const resources = {
    intro: {
        title: 'Resources',
        subTitle: (
            <>
                Whitepapers, Technical Briefs & Educational Materials
            </>
        ),
    },
    subIntro: {
        children: (
            <>
                In-depth technical documentation covering our quantum computing and post-quantum
                cryptography solutions. Download our whitepapers to learn more about how quantum
                technology can transform your organization.
            </>
        ),
    },
    cardsGroup: {
        title: 'Whitepapers',
        children: [
            {
                icon: 'icon-processor',
                title: 'Hybrid Quantum Optimization',
                card: 'Comprehensive overview of our hybrid quantum-classical approach to solving industry-scale optimization problems. Covers problem encoding, AI preprocessing, quantum execution, and solution extraction. (24 pages)',
            },
            {
                icon: 'icon-shield-check',
                title: 'The Qaser Framework',
                card: 'Detailed guide to our post-quantum cryptography framework, from discovery through continuous management. Includes implementation strategies, deployment models, and compliance considerations. (32 pages)',
            },
            {
                icon: 'icon-shield-check',
                title: 'QamiaLayer Technical Brief',
                card: 'Technical deep-dive into our proxy-based approach to quantum-safe communications. Explains how ML-KEM tunneling provides immediate protection without code changes. (18 pages)',
            },
            {
                icon: 'icon-clipboard-plus',
                title: 'PQC Library Benchmarks',
                card: 'Comprehensive benchmarking of our homegrown NIST-compliant cryptographic implementations. Includes performance comparisons, security analysis, and implementation details. (28 pages)',
            },
        ],
    },
    divider1: {},
    servicesSection: {
        title: 'Training & Education',
        children: [
            {
                title: 'Training Programs',
                description: 'Comprehensive quantum computing and post-quantum cryptography training for technical teams and executives. From fundamentals to advanced implementation.',
            },
            {
                title: 'Workshops',
                description: 'Hands-on workshops to explore quantum optimization use cases and PQC migration strategies tailored to your industry and specific challenges.',
            },
            {
                title: 'Consulting',
                description: 'Expert consulting services to assess your quantum readiness, identify optimization opportunities, and develop your quantum security roadmap.',
            },
        ],
    },
    divider2: {},
    quote: {
        children: (
            <>
                Contact us to request access to our whitepapers or to schedule a training session
                for your team. We are here to support your quantum journey.
            </>
        ),
    },
};

export default resources;
